<ng-container>
    <div class="check__offer">
        <div class="check__offer__container">
                <div class="label">{{ data()?.offering_text }}</div>
            <div class="input__section">
                    <input-msisdn [formControl]="msisdn" [isShowResetInput]="!(promoType() === 'claimVoucher')" (resetEvent)="onClickResetInput()" (validEvent)="valid.set($any($event))" />
                @if(promoType() !== 'claimVoucher') {
                    <ng-container *ngTemplateOutlet="submit; context: contextDataButton()" />
                }
            </div>
        </div>
    </div>
    
    <!-- TNC -->
    @if (promoType() === 'claimVoucher') {
        <app-tnc-basic [termsContent]="data()?.terms"/>
        <ng-container *ngTemplateOutlet="submit; context: contextDataButton()" />
    }
    
    <!-- LIST PACKAGES AND POINS -->
    @if (!isLoadOffer()) {
        @if(offerListResult().packages.length > 0 || offerListResult().poins.length > 0) {
            <app-offer-list [campaignId]="campaignId()" [isAffiliatePackage]="isAffiliatePackage()" [data]="offerListResult()" [promoType]="promoType()" [msisdn]="msisdn.value"/>
        }
    } @else {
        <shared-loader/>
    }

    @if(promoType() === 'migrateHalo' && validateHaloNumberData() !== null) {
        <app-migrate-halo [msisdn]="msisdn.value" [data]="validateHaloNumberData()!"/>
    }
    
    <!-- BUTTON FOR SUBMIT CHECKING MSISDN -->
    <ng-template #submit let-text="text">
        <button 
            class="submit" [disabled]="!(valid() && msisdn.value !== '')" [ngClass]="[
            valid() && msisdn.value !== '' ? 'submit--active' : 'submit--disable',
            promoType() === 'claimVoucher' ? 'submit__long' : 'submit__short' ]"
            (click)="onClickCheckMsisdn()"
        >{{text}}</button>
    </ng-template>
</ng-container>